import React from 'react'
import { useSelector } from 'react-redux'
import { TouchableOpacity } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StyleService } from '@src/style/service'
import { InlineAlert } from '@src/components/InlineAlert'
import { sensorSelector } from '@src/selectors/sensor'
import { UiInlineAlert } from '@src/types'

export const SensorStatusPopup = () => {
  const navigation = useNavigation()
  const sensor = useSelector(sensorSelector)

  if (!sensor?.lastStatusChange?.failure) {
    return null
  }

  const onPress = () => {
    navigation.navigate('SupportHub')
  }

  return (
    <TouchableOpacity
      accessibilityLabel="Sensor failed - contact support"
      activeOpacity={0.7}
      onPress={onPress}
    >
      <InlineAlert
        style={styles.popup}
        category={UiInlineAlert.Danger}
        message="Sensor failed. Do not remove — tap to contact customer support now."
      />
    </TouchableOpacity>
  )
}

const styles = StyleService.create({
  popup: {
    marginHorizontal: 16,
    marginTop: 8,
  },
})
